// extracted by mini-css-extract-plugin
export var HR = "textgrid-module--HR--3x3rr";
export var title = "textgrid-module--title--2NKZm";
export var itemTitle = "textgrid-module--item-title--hYvwe";
export var itemText = "textgrid-module--item-text--eHDW6";